import { ReactNode } from "react";
import Accordion from "react-bootstrap/Accordion";

interface IProps {
  items: IPropsInfo[];
  autoOpenKey?: number | undefined;
}

interface IPropsInfo {
  title: string;
  html: ReactNode;
}

export default function AccordionHTML({ items, autoOpenKey }: IProps) {
  if (!items || items.length === 0) return null;

  return (
    <Accordion defaultActiveKey={autoOpenKey !== undefined ? `${autoOpenKey}` : ``} className="w-full max-w-md mx-auto">
      {items.map((item, index) => (
        <Accordion.Item eventKey={String(index)} key={index}>
          <Accordion.Header>{item.title}</Accordion.Header>
          <Accordion.Body>{item.html}</Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}